import { Link } from 'react-router-dom';

const STEPS = [
  { icon: 'ri-mail-send-line', step: '01', title: '提交线索', desc: '通过邮箱匿名投稿，或先在评论区留下行业关键词，编辑会跟进' },
  { icon: 'ri-file-search-line', step: '02', title: '分级核实', desc: '编辑核对佐证，区分「已核实 / 待核实」，重大内容给相关方回应机会' },
  { icon: 'ri-newspaper-line', step: '03', title: '发布呈现', desc: '打码后发布并标注状态，尊重事实与隐私，持续跟踪更新' },
];

const SUBMIT_BG =
  'https://readdy.ai/api/search-image?query=Abstract%20editorial%20band%20background%20of%20open%20mailbox%20and%20flying%20paper%20letters%20in%20warm%20amber%20and%20cream%20on%20soft%20vermilion%20tint%2C%20gentle%20gradient%2C%20magazine%20style%2C%20no%20text%2C%20no%20clutter&width=1600&height=720&seq=submit-banner-1&orientation=landscape';

export default function SubmitCta() {
  return (
    <section id="submit" className="relative scroll-mt-28 overflow-hidden">
      <img src={SUBMIT_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/95 via-primary-800/85 to-primary-900/90"></div>
      <div className="relative mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-300">
              <i className="ri-megaphone-fill" aria-hidden="true"></i>
              你的消息值得被听见
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold leading-tight text-background-50 md:text-3xl">
              知道别人不知道的内部动态？
              <br />
              <span className="text-accent-300">把它安全地告诉我们</span>
            </h2>
            <p className="mt-3 max-w-md text-sm leading-7 text-primary-100">
              无论是一次组织变动、一条内部政策，还是长期被忽略的一线困境，都可以匿名分享。你的投稿将帮助更多人看清真实职场。
            </p>
            <Link
              to="/about#contact"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-lock-2-fill" aria-hidden="true"></i>
              匿名提交我的线索
            </Link>
          </div>
          <div className="flex flex-col gap-4 lg:col-span-7">
            {STEPS.map((s) => (
              <div
                key={s.step}
                className="flex items-start gap-4 rounded-lg border border-primary-200/20 bg-primary-950/40 p-5 backdrop-blur"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500 text-xl text-foreground-950">
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <p className="flex items-center gap-2 text-xs font-medium text-accent-300">
                    <span className="font-display text-primary-200">STEP {s.step}</span>
                    {s.title}
                  </p>
                  <p className="mt-1.5 text-sm leading-6 text-primary-100">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}